import React from "react";
import YouTube from "react-youtube";

interface Props {
  title: string;
  videoId: string;
}

export const YoutubeModal = (props: Props) => {
  const { title, videoId } = props;
  return  (
    <>
      <h4 className="my-3 text-center">
        {title}
      </h4>
      <YouTube
        containerClassName="mt-5 my-5 d-flex justify-content-center ml-2"
        videoId={videoId}
        opts={{
        height: '390',
        width: '550',
        playerVars: {
            autoplay: 0
        }
        }}
      />
    </>
  );
};



